import { render } from "./EditCourse.vue?vue&type=template&id=510e3916"
import script from "./EditCourse.vue?vue&type=script&lang=js"
export * from "./EditCourse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__